// Aggregate utility functions for video file handling
// Add support for new video types here

// Check if the file is a video using mimetype
export function isVideoMimeType(fileType) {
  return fileType === "video/mp4";
}

// Checks if we are interacting with a video based on the file name's extension
// For use when the file type is not available (e.g., when only the file name is provided)
export function isVideoFileName(fileName) {
  return fileName.toLowerCase().endsWith(".mp4");
}
